import PropTypes from 'prop-types';
import { Snackbar } from '@material-ui/core';
import { NO_ACTIVE_PAYER_USERS_MESSAGE } from './consts';

const NoActiveUsersSnackbar = ({ onClose, open }) => (
  <Snackbar
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    autoHideDuration={8000}
    message={NO_ACTIVE_PAYER_USERS_MESSAGE}
    onClose={onClose}
    open={open}
  />
);

NoActiveUsersSnackbar.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default NoActiveUsersSnackbar;
